export default __webpack_public_path__ + "static/media/fsplus-product-selection.6dbec4cf.png";